<template>
    <div id="navigation_left"
        :style="{
            color: (is_inverted) ? 'white' : 'black',
            paddingTop: (top) ? '0px' : '25%',
            top: (top) ? top : '0',
        }">
        <i class="caret left icon"></i>
    </div>
</template>

<script>
export default {
    components: {
    },
    props: {
        is_inverted: {
            default: true,
            type: Boolean
        },
        top: {
            default: "",
            type: String
        },
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    watch: {
    },
    computed: {
    },
    methods: {
    },

}
</script>

<style lang="scss" scoped>
    #navigation_left {
        position: absolute;
        left: 0;
        padding: 6px;
        font-size: 30px;
        z-index: 1;
    }
</style>
